import { Link } from '@tanstack/react-router'
import { ShieldAlert } from 'lucide-react'
import type { ReactElement } from 'react'

import { EmptyState } from '@/components/state/empty-state'
import { Button } from '@/components/ui/button'

/**
 * Rota existente, permissão ausente.
 *
 * É diferente de "página não encontrada": aqui o endereço existe e a pessoa
 * simplesmente não tem a permissão. Dizer isso claramente evita o chamado de
 * suporte "o sistema está quebrado" quando o correto é "peça o acesso ao
 * gestor".
 */
export function AcessoNegadoPage(): ReactElement {
  return (
    <div className="mx-auto w-full max-w-2xl p-2">
      <EmptyState
        icone={ShieldAlert}
        titulo="Você não tem acesso a esta área"
        descricao="Seu papel não inclui a permissão necessária. Se você precisa dela para trabalhar, peça ao gestor da operação."
        acao={
          <Button asChild variant="secondary">
            <Link to="/">Voltar para a visão geral</Link>
          </Button>
        }
      />
    </div>
  )
}
